const styles = {
  spacer: {
    flex: 1
  }
}

export default styles
